/* ============================================================================
   LITELOK Pre-sell — shared behaviour for the modular section set.
   Loaded once (guarded). Scans the whole document, so it works no matter how
   many ll-* sections are present or what order they're in. Re-scans when the
   theme editor (re)loads a section.
   ========================================================================== */
(function () {
  if (window.__llPresellInit) return;
  window.__llPresellInit = true;

  document.documentElement.classList.add('ll-anim');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Video modal (single instance on <body>) ---------- */
  var modal, mediaBox;
  function ensureModal() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'll-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<div class="ll-modal__backdrop" data-ll-close></div>' +
      '<div class="ll-modal__dialog">' +
        '<button type="button" class="ll-modal__close" data-ll-close aria-label="Close video">&times;</button>' +
        '<div class="ll-modal__media"></div>' +
      '</div>';
    document.body.appendChild(modal);
    mediaBox = modal.querySelector('.ll-modal__media');
  }
  function toEmbed(url) {
    if (!url) return null;
    url = url.trim();
    if (!url) return null;
    var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
    if (yt) return { type: 'iframe', src: 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0&playsinline=1' };
    var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return { type: 'iframe', src: 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1' };
    if (/\.(mp4|webm|ogv|mov)(\?|#|$)/i.test(url)) return { type: 'video', src: url };
    return { type: 'iframe', src: url };
  }
  function openModal(url) {
    var v = toEmbed(url);
    if (!v) return;
    ensureModal();
    mediaBox.innerHTML = v.type === 'video'
      ? '<video src="' + v.src + '" controls autoplay playsinline></video>'
      : '<iframe src="' + v.src + '" allow="autoplay; fullscreen; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    mediaBox.innerHTML = '';
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('.ll-video-trigger') : null;
    if (t) { e.preventDefault(); openModal(t.getAttribute('data-ll-video')); return; }
    if (e.target.closest && e.target.closest('[data-ll-close]')) closeModal();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  /* ---------- ?biketype= passthrough on quiz / gallery links ---------- */
  function withBikeParam(href) {
    try {
      var p = new URLSearchParams(window.location.search);
      var bike = p.get('biketype') || p.get('bike');
      if (bike) { var u = new URL(href, window.location.origin); u.searchParams.set('biketype', bike); return u.toString(); }
    } catch (e) {}
    return href;
  }
  function bindParams() {
    document.querySelectorAll('.ll-passparam').forEach(function (a) {
      if (a.dataset.llParam) return;
      a.dataset.llParam = '1';
      a.href = withBikeParam(a.getAttribute('href'));
    });
  }

  /* ---------- Scroll reveal ---------- */
  var revealIO = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); revealIO.unobserve(en.target); } });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' })
    : null;
  function bindReveal() {
    document.querySelectorAll('.ll-reveal').forEach(function (el) {
      if (el.dataset.llReveal) return;
      el.dataset.llReveal = '1';
      if (revealIO) revealIO.observe(el); else el.classList.add('is-in');
    });
  }

  /* ---------- Count-up on stat numbers ---------- */
  function animateCount(el) {
    var full = (el.textContent || '').trim();
    var m = full.match(/^([^\d]*)([\d.,]+)(.*)$/);
    if (!m) return;
    var prefix = m[1], numStr = m[2], suffix = m[3];
    var hasComma = numStr.indexOf(',') !== -1;
    var decimals = (numStr.split('.')[1] || '').length;
    var target = parseFloat(numStr.replace(/,/g, ''));
    if (isNaN(target)) return;
    function fmt(v) {
      var str = decimals ? v.toFixed(decimals) : String(Math.round(v));
      if (hasComma) { var parts = str.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); str = parts.join('.'); }
      return prefix + str + suffix;
    }
    var dur = 1100, startTs = null;
    el.textContent = fmt(0);
    function step(ts) {
      if (startTs === null) startTs = ts;
      var p = Math.min(1, (ts - startTs) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * eased);
      if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(target);
    }
    requestAnimationFrame(step);
  }
  var countIO = (!reduceMotion && 'IntersectionObserver' in window && window.requestAnimationFrame)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { animateCount(en.target); countIO.unobserve(en.target); } });
      }, { threshold: 0.5 })
    : null;
  function bindCounts() {
    document.querySelectorAll('.ll-stat b').forEach(function (el) {
      if (el.dataset.llCount) return;
      el.dataset.llCount = '1';
      if (countIO) countIO.observe(el);
    });
  }

  /* ---------- Subtle parallax (desktop + motion-on only) ---------- */
  var pxItems = [];
  var pxBound = false;
  function bindParallax() {
    var desktop = window.matchMedia && window.matchMedia('(min-width: 901px)').matches;
    if (reduceMotion || !desktop) return;
    document.querySelectorAll('.ll-parallax').forEach(function (sec) {
      if (sec.dataset.llPx) return;
      sec.dataset.llPx = '1';
      pxItems.push(sec);
    });
    if (pxItems.length && !pxBound) {
      pxBound = true;
      var ticking = false;
      function paint() {
        var vh = window.innerHeight || document.documentElement.clientHeight;
        pxItems.forEach(function (sec) {
          var media = sec.querySelector('.ll-bg__media');
          if (!media) return;
          var r = sec.getBoundingClientRect();
          if (r.bottom < -50 || r.top > vh + 50) return;
          var progress = (r.top + r.height / 2 - vh / 2) / vh;
          if (progress < -1) progress = -1; if (progress > 1) progress = 1;
          media.style.transform = 'translate3d(0,' + (progress * -14) + '%,0)';
        });
        ticking = false;
      }
      function onScroll() { if (!ticking) { ticking = true; (window.requestAnimationFrame || function (f) { f(); })(paint); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      paint();
    }
  }

  function bindCarousels() {
    document.querySelectorAll('[data-ll-carousel]').forEach(function (c) {
      if (c.dataset.llCar) return; c.dataset.llCar = '1';
      var track = c.querySelector('.ll-carousel__track');
      var prev = c.querySelector('.ll-carousel__arrow--prev');
      var next = c.querySelector('.ll-carousel__arrow--next');
      var dotsWrap = c.querySelector('.ll-carousel__dots');
      if (!track) return;
      var slides = [].slice.call(track.querySelectorAll('.ll-quote'));
      /* Carousel cards must not be reveal-gated — off-screen cards never hit the
         IntersectionObserver threshold, so show them all immediately. */
      slides.forEach(function (sl) { sl.classList.add('is-in'); });
      function step() {
        var card = slides[0];
        var gap = parseFloat((window.getComputedStyle(track).columnGap || '22')) || 22;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      }
      var dots = [];
      if (dotsWrap && slides.length > 1) {
        dotsWrap.innerHTML = '';
        slides.forEach(function (sl, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.setAttribute('aria-label', 'Go to review ' + (i + 1));
          d.addEventListener('click', function () { track.scrollTo({ left: i * step(), behavior: 'smooth' }); });
          dotsWrap.appendChild(d);
          dots.push(d);
        });
      }
      function update() {
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        if (dots.length) {
          var idx = Math.round(track.scrollLeft / step());
          if (idx < 0) idx = 0; if (idx > dots.length - 1) idx = dots.length - 1;
          dots.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
        }
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { (window.requestAnimationFrame || function (f) { f(); })(update); }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  function scan() { bindParams(); bindReveal(); bindCounts(); bindParallax(); bindCarousels(); }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
})();